/** Main url routes for the application */
import { IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { GuardedRoute } from './components/authContext/GuardedRoute';
import { GuestRoute } from './components/authContext/GuestRoute';
import { Menu } from './components/menuItems/Menu';
import { LoginPage, NewPasswordPage, ResetPasswordPage } from './pages/Login/Login';
import { ReportDetailPage } from './pages/Report';
import { ReportsPage } from './pages/ReportList';
import { UploadPage } from './pages/Upload';
import { ReportProvider } from './components/reportContext';
import { Dashboard } from './pages/Dashboard';
import { MeasurementsPage } from './pages/Measurements';
import { ORYXTest } from './pages/Measurements/ORYX/ORYX';
import { HardwareProvider } from './components/hardwareContext';
import { useAuthContext } from './components/authContext';
import { SelectNetworkPage } from './pages/Measurements/ORYX/selectNetwork';
import { UserInfoProvider } from './components/userInfoContext';
import { AdminPage } from './pages/Admin';
import { Redirect } from 'react-router';
import { DeviceManagementPage } from './pages/Device Management';
import { ReportDetailPageV2 } from './pages/ReportV2';
import { KBHomePage } from './pages/Knowlegde Base';
/** Main url routes for the application
 * FirebaseAuthConsumer provides the userId parameter to the sub pages when a user is logged in.
 * If you are not logged in only the home and login page is rendered.
 */
export const Routes = () => {
  const { isAuthorized } = useAuthContext();
  return (
    <IonReactRouter>
      {/* Note: the Nav element is needed for the side menu to know where to display itself */}
      {/* <IonNav id='main' /> */}
      {/* <Menu /> */}
      {!isAuthorized() ? (
        <IonRouterOutlet>
          <GuestRoute path='/'>
            <LoginPage />
          </GuestRoute>
          <GuestRoute path='/login'>
            <LoginPage />
          </GuestRoute>
          <GuestRoute path='/resetPassword'>
            <ResetPasswordPage />
          </GuestRoute>
          <GuestRoute path='/newPassword'>
            <NewPasswordPage />
          </GuestRoute>
        </IonRouterOutlet>
      ) : (
        <IonSplitPane contentId='main'>
          <Menu />
          <IonRouterOutlet id='main'>
            <UserInfoProvider>
              <ReportProvider>
                <GuardedRoute path='/'>
                  <Redirect to='/dashboard' />
                </GuardedRoute>
                <GuardedRoute path='/dashboard'>
                  <Dashboard />
                </GuardedRoute>
                <GuardedRoute path='/admin'>
                  <AdminPage />
                </GuardedRoute>
                <HardwareProvider>
                  <GuardedRoute path='/devicemanagement'>
                    <DeviceManagementPage />
                  </GuardedRoute>
                  <GuardedRoute path='/measurements'>
                    <MeasurementsPage />
                  </GuardedRoute>
                  <GuardedRoute path='/measurements/ORYX/:hardwareId'>
                    <ORYXTest />
                  </GuardedRoute>
                  <GuardedRoute path='/measurements/ORYX/selectNetwork'>
                    <SelectNetworkPage />
                  </GuardedRoute>
                </HardwareProvider>
                <GuardedRoute path='/reports'>
                  <ReportsPage />
                </GuardedRoute>
                <GuardedRoute path='/reports/:id'>
                  <ReportDetailPage />
                </GuardedRoute>
                <GuardedRoute path='/reportsV2/:id'>
                  <ReportDetailPageV2 />
                </GuardedRoute>
                <GuardedRoute path='/upload'>
                  <UploadPage />
                </GuardedRoute>

                <GuardedRoute path='/docs'>
                  <KBHomePage />
                </GuardedRoute>
              </ReportProvider>
            </UserInfoProvider>
          </IonRouterOutlet>
        </IonSplitPane>
      )}
    </IonReactRouter>
  );
};
